import { render, staticRenderFns } from "./editorAssemblyItemDialog.vue?vue&type=template&id=1a77aeb5&"
import script from "./editorAssemblyItemDialog.vue?vue&type=script&lang=js&"
export * from "./editorAssemblyItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports